module.exports = __webpack_public_path__ + "static/nxrt-rail4-1c9202d8751ceb92741b8147a1c83e12.jpg";